import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomTable from "../../../../../components/custom-table/custom-table";
import { LoaderMessage } from "../../../../../components/loaderMessage/loaderMessage";
import { RootState } from "../../../../../redux/store/store";
import { logOrderClickedEvent } from "../../../../../utils/events";
import { generateDataForPatientsOrdersTable } from "../../../../../utils/generateOrderDataForTable";
import { ScreenName } from "../../../../../utils/screenName";
import {
  generateUiDataForPatientsOrderTable,
  PatientOrdersTableColumns,
} from "./patientOrdersTableData";

interface PatientOrdersTableProps {
  tableName: string;
}

const PatientOrdersTable = (props: PatientOrdersTableProps) => {
  const { data: ordersData, loading } = useSelector(
    (state: RootState) => state.ordersForPatient,
  );

  const [dataForTable, setDataForTable] = useState<any[]>([]);
  const navigate = useNavigate();

  const navigateToSingleOrder = (rowData) => {
    logOrderClickedEvent(rowData.docId ?? "N/A");
    navigate(`/worklists/singleOrder/${rowData.docId}`, {
      state: {
        fromScreen: ScreenName.PATIENT_ORDER,
      },
    });
  };

  useEffect(() => {
    if (ordersData) {
      const ordersDataForTable = generateDataForPatientsOrdersTable(ordersData);
      setDataForTable(generateUiDataForPatientsOrderTable(ordersDataForTable));
    }
  }, [ordersData]);
  return (
    <>
      {loading ? (
        <LoaderMessage message={"Fetching Orders"} />
      ) : (
        <div
          className="patient-orders-table--container"
          style={{ height: "100%" }}
        >
          <CustomTable
            tableHeaders={PatientOrdersTableColumns}
            tableData={dataForTable}
            itemsPerPage={6}
            pagesPerView={5}
            count={dataForTable.length}
            onRowClick={navigateToSingleOrder}
            tableName={`patientOrder-${props.tableName}`}
          />
        </div>
      )}
    </>
  );
};

export default PatientOrdersTable;
